<template>
  <fragment
    v-bind:title="title"
    v-on:remove="$emit('remove')"
  >
    <label class="fragment-text">
      <input
        class="fragment-text__input"
        type="text"
        v-model="text" />
    </label>
  </fragment>
</template>
<script>
import Fragment from '@/components/NotificationPlan/Fragment.vue';

/**
 * @description Фрагмент вводимого текста формы создания шаблона СМС.
 * @type {Vue}
 */
export default {
  components: {
    Fragment,
  },
  data() {
    return {
      text: this.value,
    };
  },
  name: 'NotificationPlanText',
  props: {
    ...Fragment.props,
    value: {
      default: () => '',
      type: String,
    },
  },
  watch: {
    text() {
      this.$emit('input', this.text);
    },
  },
};
</script>
<style lang="scss" scoped>
.fragment-text {
  &__input {
    border: 1px solid var(--border-color);
    border-radius: var(--input-border-radius);
    padding: .3rem .625rem;
  }
}
</style>
